import {
  LINKS,
  IMAGES,
  IMAGES_PREVIEW,
  ABOUT,
  ABOUT_CONTENT,
  ABOUT_CONTENT_RAW,
  OPEN,
  EDIT,
  CUSTOM,
  SELECT_TOOLBAR
 } from '../constants';

export const setLinks = (text) => ({ type: LINKS, payload: text })

export const setImages = (text) => ({ type: IMAGES, payload: text })

export const setImagesPreview = (text) => ({ type: IMAGES_PREVIEW, payload: text })

export const setAbout = (text) => ({ type: ABOUT, payload: text })

export const setAboutContent = (text) => ({ type: ABOUT_CONTENT, payload: text })

export const setAboutContentRaw = (text) => ({ type: ABOUT_CONTENT_RAW, payload: text })

export const setActivitiesOpen = (text) => ({ type: OPEN, payload: text })

export const setActivitiesEdit = (text) => ({ type: EDIT, payload: text })

export const setCustomization = (text) => ({ type: CUSTOM, payload: text })

export const setSelectToolbar = (text) => ({ type: SELECT_TOOLBAR, payload: text })